import { useMemo } from "react";
import { useCentralStore } from "../../store/Central";
import {
	SheetContentType,
	useSheetStore,
} from "../../store/Sheets/sheet.store";
import { ArticleDialog } from "./article-dialog.component";
import { ArticlesTable } from "./articles-table.component";
import { ScanSearch } from "lucide-react";
import { Button } from "../../components/ui/button";

export const ArticlesOverviewPage = () => {
	// Subscribe to the stable store reference and flatten the double-nested
	// structure (code_e -> id -> article) in a memo, so the page only re-renders
	// when articles actually change instead of on every central-store update.
	const articlesMap = useCentralStore((state) => state.articles);
	const articles = useMemo(
		() =>
			Object.values(articlesMap).flatMap((codeGroup) =>
				Object.values(codeGroup)
			),
		[articlesMap]
	);
	const openSheet = useSheetStore((state) => state.openSheet);
	return (
		<div className="h-full flex flex-col min-h-0">
			<ArticlesTable
				articles={articles}
				onRowClick={(article) =>
					openSheet(SheetContentType.ARTICLE, {
						articleId: article.id,
					})
				}
				actions={
					<>
						<ArticleDialog />
						<Button
							variant="outline"
							size="sm"
							icon={<ScanSearch />}
							shortcut="r"
							onClick={() =>
								openSheet(
									SheetContentType.MATERIAL_TRACEABILITY,
									{}
								)
							}
							aria-label="Materialienrückverfolgung über alle Artikel öffnen"
							data-testid="open-global-traceability-button"
						>
							Rückverfolgung
						</Button>
					</>
				}
			/>
		</div>
	);
};
